const en = {
  message: {
    Save_cmd: 'Save',
    Close_cmd: 'Close',
    Del_cmd: 'Delete',
    Query_cmd: 'Query',
    Send_cmd: 'Send',
    CSave_cmd: 'Save',
    Sign_in: 'Login',
    Sign_out: 'Logout',
    Confirm_txt: 'OK',
    Load_txt: 'Loading',
    Error_txt: 'Error',
    Success_txt: 'Success',
    Warning_txt: 'Warning',
    Info_txt: 'Info',
    Upload_txt: 'Upload',
    Back_txt: 'Back',
    Next_txt: 'Next',
    Keep_txt: 'Keep',
    Preview_txt: 'Preview',
    NextPage_txt: 'Next',
    Check_txt: 'Check',
    Cancel_txt: 'Cancel',
    ID_txt: 'ID',
    PassW_txt: 'Password',
    ValiC_txt: 'Validate Code',
    Contacts_txt: 'Contacts',
    Report_txt: 'Report',
    Excel_txt: 'Excel',
    Edit_txt: 'Edit',
    Home_txt: 'Home',
    NCUT_txt: 'NCUT',
    Download_txt: 'Download'
  } 
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js